import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from './ui/Modal';
import Button from './ui/Button';
import { apiClient } from '../utils/apiClient';
import { Globals } from '../globalfunctions.js';
import { subscribeToTicketEvents } from '../utils/ticketEventStream';
import { describeDue } from '../utils/followups';
import './FollowUps.css';

// "Reminders" button for the Tickets toolbar: shows how many of your
// follow-ups are due and opens a list of all of them across tickets.
export default function MyFollowUps() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    apiClient.get('/api/ticket-followups/mine')
      .then((rows) => setItems(Array.isArray(rows) ? rows : []))
      .catch(() => setItems([]));
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => subscribeToTicketEvents((e) => {
    if (e.type === 'followup-due' && e.payload && Number(e.payload.user_id) === Number(Globals.Id)) load();
  }), [load]);

  const dueCount = items.filter((i) => describeDue(i.due_at).overdue).length;

  const finish = async (id, remove) => {
    setError('');
    try {
      if (remove) await apiClient.delete(`/api/ticket-followups/${id}`);
      else await apiClient.put(`/api/ticket-followups/${id}/done`, {});
      load();
    } catch (err) {
      setError(err.message || 'Could not update the reminder.');
    }
  };

  if (items.length === 0 && !open) return null;

  return (
    <>
      <Button variant="secondary" onClick={() => { load(); setOpen(true); }} title="Your follow-up reminders">
        <i className="fas fa-bell" aria-hidden="true"></i> Reminders
        {items.length > 0 && <span className={`fu-count${dueCount ? ' is-due' : ''}`}>{dueCount || items.length}</span>}
      </Button>
      <Modal open={open} onClose={() => setOpen(false)} title="My follow-ups" footer={<Button variant="secondary" onClick={() => setOpen(false)}>Close</Button>}>
        {items.length === 0 ? <p className="fu-empty">You have no open follow-ups.</p> : (
          <ul className="fu-list fu-list-page">
            {items.map((item) => {
              const due = describeDue(item.due_at);
              return (
                <li key={item.id} className={due.overdue ? 'is-due' : ''}>
                  <div className="fu-main">
                    <strong>{due.overdue ? `Due now (${due.label})` : due.label}</strong>
                    <Link to={`/tickets/${item.ticket_id}`} onClick={() => setOpen(false)}>
                      #{item.ticket_number} {item.ticket_subject || ''}
                    </Link>
                    {item.note && <span>{item.note}</span>}
                  </div>
                  <button type="button" className="fu-icon" onClick={() => finish(item.id, false)} aria-label="Mark follow-up done" title="Done"><i className="fas fa-check" aria-hidden="true"></i></button>
                  <button type="button" className="fu-icon" onClick={() => finish(item.id, true)} aria-label="Delete follow-up" title="Delete"><i className="fas fa-xmark" aria-hidden="true"></i></button>
                </li>
              );
            })}
          </ul>
        )}
        {error && <p className="fu-error" role="alert">{error}</p>}
      </Modal>
    </>
  );
}
